import Handlebars from "handlebars";
import { sortBy } from "lodash";
import pickBy from "lodash/pickBy";
import { DataTableSortStatus } from "mantine-datatable";

import {
  DeskCollectionFilter,
  DeskCollectionOrderBy,
  StringFilterMode,
} from "../../graphql/generated.ts";
import { DeskCollection } from "../../types/deskCollection/deskCollection.ts";
import { getApiOrderBy } from "../../utils/api.ts";
import { toLocalDate } from "../../utils/date.ts";
import { toCurrencyPrice } from "../../utils/number.ts";
import { FilterValue } from "./types.ts";

export const getDeskCollectionApiSort = (
  tableSort: DataTableSortStatus
): DeskCollectionOrderBy => {
  const { customerName, template, ...apiSort } = getApiOrderBy(tableSort);
  return {
    ...apiSort,
    customer: customerName && { name: customerName },
    template: template && { name: template },
  };
};

export const getDeskCollectionApiFilter = (
  filter: FilterValue
): DeskCollectionFilter => {
  return pickBy({
    customerId: filter.customerId && { equals: filter.customerId },
    invoices: pickBy({
      some: pickBy({
        invoiceNumber: filter.invoiceNumber && {
          contains: filter.invoiceNumber,
          mode: StringFilterMode.Insensitive,
        },
        dpd: filter.dpd && { equals: filter.dpd },
        invoiceDueDate: filter.invoiceDueDate && {
          equals: filter.invoiceDueDate,
        },
      }),
    }),
  });
};

export const generateDeskCollectionMessage = (item: DeskCollection) => {
  if (!item.template) {
    return null;
  }
  const template = Handlebars.compile(item.template.template);
  return template({
    CustomerName: item.customer.name,
    PICName: item.picName,
    Invoices: sortBy(item.invoices, "dpd").map((invoice) => ({
      InvoiceNumber: invoice.invoiceNumber,
      TotalAmountDue: toCurrencyPrice(invoice.totalInvoice, "Rp"),
      TotalAccountReceivable: toCurrencyPrice(
        invoice.totalAccountReceivable,
        "Rp"
      ),
      InvoiceDueDate: toLocalDate(invoice.invoiceDueDate),
      DueDateFromToday: invoice.dpd ?? "None",
    })),
  });
};
